import { track, trackYouLeadForm } from "./track-event"

// Generic, declarative form tracking — opt a form in via data attributes:
//   data-track-form="contact"                                    → contact_form_started + contact_form_submitted
//   data-track-form="checkout" data-track-form-events="started"   → only the _started event
//   data-track-youlead                                           → also fire Monitor.TrackForm(id) on submit
//
// "started" fires on the first interaction (input/change). "submitted" fires on submit.
// Non-AJAX forms reload the page on submit, so we briefly block the submit, fire the
// analytics (dataLayer/GTM tags + YouLead beacon), then re-submit — otherwise the page
// unloads before the beacons go out. AJAX forms (data-remote="true") are never blocked.
const SUBMIT_DELAY = 300

const setupStarted = (form, name) => {
  let fired = false

  const onStart = () => {
    if (fired) {
      return
    }

    fired = true

    track(`${name}_form_started`)

    form.removeEventListener("input", onStart)
    form.removeEventListener("change", onStart)
  }
  form.addEventListener("input", onStart)
  form.addEventListener("change", onStart)
}

const setupSubmitted = (form, name, { emitEvent, youlead }) => {
  const isRemote = form.dataset.remote === "true"

  form.addEventListener("submit", (event) => {
    if (emitEvent) {
      track(`${name}_form_submitted`)
    }

    if (youlead) {
      trackYouLeadForm(form.id)
    }

    if (!isRemote) {
      event.preventDefault()
      setTimeout(() => form.submit(), SUBMIT_DELAY)
    }
  })
}

const setupForm = (form) => {
  const name = form.dataset.trackForm
  const youlead = form.dataset.trackYoulead !== undefined
  const defaultEvents = name ? "started submitted" : "none"
  const events = (form.dataset.trackFormEvents ?? defaultEvents)
    .split(/\s+/)
    .filter(Boolean)

  if (events.includes("started")) {
    setupStarted(form, name)
  }

  const emitEvent = events.includes("submitted")

  if (emitEvent || youlead) {
    setupSubmitted(form, name, { emitEvent, youlead })
  }
}

document.addEventListener("DOMContentLoaded", () => {
  for (const form of document.querySelectorAll(
    "[data-track-form], [data-track-youlead]",
  )) {
    setupForm(form)
  }
})
